import { faCopy, faEnvelope, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./ModalShare.module.scss";

import { faFacebook, faTelegram } from "@fortawesome/free-brands-svg-icons";
import { message } from "antd";
import { useEffect, useState } from "react";
import { callFetchPostByID } from "../../../../config/api";

function ModalShare(props: any) {
  const [postDetail, setPostDetail] = useState<any>({});

  useEffect(() => {
    const fetchPostByID = async () => {
      const res: any = await callFetchPostByID(props.postId);
      if (res.statusCode === 200) {
        setPostDetail(res.data);
      }
    };
    fetchPostByID();
    updateMetaTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.postId]);

  const updateMetaTags = () => {
    if (!postDetail) return;
    const shareUrl = `https://www.devbetter.pro/post-detail/${props.postId}`;
    const shareTitle = postDetail.title;
    const shareDescription = "Bấm vào đây để xem chi tiết bài viết";
    const shareImage = postDetail.image;

    const metaTags = [
      { property: "og:title", content: shareTitle },
      { property: "og:description", content: shareDescription },
      { property: "og:image", content: shareImage },
      { property: "og:url", content: shareUrl },
    ];

    metaTags.forEach((tag) => {
      const existingTag = document.querySelector(
        `meta[property="${tag.property}"]`
      );
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const newTag = document.createElement("meta");
        newTag.setAttribute("property", tag.property);
        newTag.setAttribute("content", tag.content);
        document.head.appendChild(newTag);
      }
    });
  };
  const shareOnFacebook = (id: string) => {
    const shareUrl = `https://www.devbetter.pro/post-detail/${id}`;
    const facebookShareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      shareUrl
    )}`;
    window.open(facebookShareLink, "_blank");
  };

  //   const shareOnZalo = (id: string) => {
  //     const shareUrl = `https://www.devbetter.pro/post-detail/${id}`;
  //     const zaloShareLink = `https://zalo.me/share?u=${encodeURIComponent(
  //       shareUrl
  //     )}`;
  //     window.open(zaloShareLink, "_blank");
  //   };

  const shareOnEmail = (id: string) => {
    const url = `https://www.devbetter.pro/post-detail/${id}`;
    const emailSubject = "Subject của email";
    const emailBody = `Chia sẻ bài viết:\n${url}`;
    const emailLink = `mailto:?subject=${encodeURIComponent(
      emailSubject
    )}&body=${encodeURIComponent(emailBody)}`;
    window.location.href = emailLink;
  };

  const shareOnTelegram = (id: string) => {
    const url = `https://www.devbetter.pro/post-detail/${id}`;
    const telegramShareLink = `https://t.me/share/url?url=${encodeURIComponent(
      url
    )}`;
    window.open(telegramShareLink, "_blank");
  };

  const copyToClipboard = () => {
    const shareUrl = `https://www.devbetter.pro/post-detail/${props.postId}`;
    const el = document.createElement("textarea");
    el.value = shareUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    message.success("Đã sao chép thành công!");
  };

  return (
    <div className={styles.actionLike}>
      <FontAwesomeIcon icon={faShare} size="1x" />
      <span>share</span>
      <ul className={styles.browse_share_group}>
        <li onClick={() => shareOnFacebook(props.postId)}>
          {" "}
          <FontAwesomeIcon icon={faFacebook} size="1x" /> Facebook
        </li>
        {/* <li onClick={() => shareOnZalo(props.postId)}>
          <FontAwesomeIcon icon={faBook} size="1x" />
          Zalo
        </li> */}
        <li onClick={() => shareOnEmail(props.postId)}>
          <FontAwesomeIcon icon={faEnvelope} size="1x" />
          Email
        </li>
        <li onClick={() => shareOnTelegram(props.postId)}>
          <FontAwesomeIcon icon={faTelegram} size="1x" />
          Telegram
        </li>

        <li onClick={copyToClipboard}>
          {" "}
          <FontAwesomeIcon icon={faCopy} size="1x" />
          <p>Copy URL</p>
        </li>
      </ul>
    </div>
  );
}

export default ModalShare;
